module.exports = __webpack_public_path__ + "static/media/omf.12f35c0e.png";